import React, { useState, useEffect, useRef } from "react";
import { Radio, Button, Select } from "antd";
import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import {
  setShareSelectedDeepdiveWidget,
  setSharedDuration,
} from "../../../redux/actions/share/Share";
import {
  setDateTimeFlag,
  updateDashboardDuration,
  updateSectionDuration,
  setGlobalDateValue,
  setSectionDateValue,
  updateWidgetDuration,
  setWidgetDateValue,
  setGraphPageDateValue,
  setSplitDateValue,
  setOrmDateValue,
  setPrevieDate,
  setCommandCenterDateValue,
} from "../../../redux/actions/DateTime";
import {
  setClearGraphData,
  setPaneDuration,
  setSelectedDeepdiveWidget,
} from "../../../redux/actions/dashboard/Tab1";
import {
  setDiffInDays,
  getPaneIndex,
  getThreeSplitDate,
  getCustomizedDate,
  getTimeInterval,
  handleScheduleDateChange,
  handleGenerateDateChange,
  useQuery,
  updateHighchartOptionData,
  getWidgetMakerFlag,
  callNotification,
  getEmptyFieldNotification,
  splitSectionWidgets,
  deepCopy,
  checkForDuplicateWidgets,
  getFilterDuplicateWidgets,
} from "../../../redux/constants";
import { setGlobalSelectedWidgetId } from "../../../redux/actions/dashboard/dashboard";
import { setGlobalDuration } from "../../../redux/actions/AuthParams";
import { setScheduleReport } from "../../../redux/actions/scheduleReport/scheduleReport";
import {
  setTemplateDetails,
  setTemplateFilter,
} from "../../../redux/actions/section/section";
import { setGraphDuration } from "../../../redux/actions/dashboard/Welcome";

const { Option } = Select;

const CustomDurationCalendar = ({
  type = "global_dashboard", // Default type
  split = null, // For split views
  onDoneCallback = null, // Optional callback for custom actions
  dashboard = false,
  crisis = null,
}) => {
  const visitedWidgetId = useSelector(
    (state) => state?.dashboard?.visited_widget_id
  );
  const query = useQuery();
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const dispatch = useDispatch();
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const scheduleObj = useSelector((state) => state.scheduleReport.scheduleObj);
  const globalDuration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);

  // Redux state
  const dateValue = useSelector((state) => state.DateTime.dateValue);
  const timeValue = useSelector((state) => state.DateTime.timeValue);

  // States
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [durationType, setDurationType] = useState("daily"); // 'daily', 'weekly', 'monthly'
  const [selectedMonth, setSelectedMonth] = useState(
    moment().subtract(1, "day").month()
  );
  const [selectedDate, setSelectedDate] = useState(
    moment().subtract(1, "day").date()
  );
  const [selectedWeek, setSelectedWeek] = useState(1);
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [displayText, setDisplayText] = useState("Select duration");
  const [popupPosition, setPopupPosition] = useState({ right: 0 });
  const [localDate, setLocalDate] = useState(null);
  const [localTime, setLocalTime] = useState({
    startTime: "00:00",
    endTime: "23:59",
  });

  const containerRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    initializeComponentState();
  }, [timeValue, dateValue]);

  // gets date from redux and sets in local display
  const initializeComponentState = () => {
    let currentData;
    let currentTimeData;
    const defaultDates = getCustomizedDate(6, "Days");
    // Set initial values based on type
    if (type === "global_dashboard") {
      const index = getPaneIndex(panes, activeKey);
      const global_duration = index >= 0 ? panes[index]?.duration : null;

      if (global_duration?.from) {
        // If global duration exists in panes
        currentData = [
          moment(global_duration.from.split(" ")[0]).format("YYYY-MM-DD"),
          moment(global_duration.to.split(" ")[0]).format("YYYY-MM-DD"),
        ];

        currentTimeData = {
          startTime: global_duration.from.split(" ")[1] || "00:00",
          endTime: global_duration.to.split(" ")[1] || "23:59",
        };
        // console.log(`[${type}] Loading dates from panes:`, currentData);
      } else if (dateValue[type]?.data) {
        // If date value exists in Redux
        currentData = dateValue[type].data;
        currentTimeData = timeValue[type]?.data || defaultDates.time;
        // console.log(`[${type}] Loading dates from Redux:`, currentData);
      } else {
        // Default fallback
        currentData = defaultDates.date;
        currentTimeData = defaultDates.time;
        // console.log(`[${type}] Using default dates:`, currentData);
      }
    } else if (type === "template_global") {
      const template_duration = templateDetails?.templateDuration;

      if (template_duration?.from) {
        // If template duration exists
        currentData = [
          moment(template_duration.from.split(" ")[0]).format("YYYY-MM-DD"),
          moment(template_duration.to.split(" ")[0]).format("YYYY-MM-DD"),
        ];

        currentTimeData = {
          startTime: template_duration.from.split(" ")[1] || "00:00",
          endTime: template_duration.to.split(" ")[1] || "23:59",
        };
        // console.log(`[${type}] Loading dates from template:`, currentData);
      } else if (dateValue[type]?.data) {
        // If date value exists in Redux
        currentData = dateValue[type].data;
        currentTimeData = timeValue[type]?.data || defaultDates.time;
        // console.log(`[${type}] Loading dates from Redux:`, currentData);
      } else {
        // Default fallback
        currentData = defaultDates.date;
        currentTimeData = defaultDates.time;
        // console.log(`[${type}] Using default dates:`, currentData);
      }
    } else if (type === "share_modal") {
      if (sharedDuration?.from) {
        currentData = [
          moment(sharedDuration.from.split(" ")[0]).format("YYYY-MM-DD"),
          moment(sharedDuration.to.split(" ")[0]).format("YYYY-MM-DD"),
        ];

        currentTimeData = {
          startTime: sharedDuration.from.split(" ")[1] || "00:00",
          endTime: sharedDuration.to.split(" ")[1] || "23:59",
        };
        // console.log(
        //   `[${type}] Loading dates from sharedDuration:`,
        //   currentData
        // );
      } else if (dateValue[type]?.data) {
        currentData = dateValue[type].data;
        currentTimeData = timeValue[type]?.data || defaultDates.time;
        // console.log(`[${type}] Loading dates from Redux:`, currentData);
      } else {
        currentData = defaultDates.date;
        currentTimeData = defaultDates.time;
        // console.log(`[${type}] Using default dates:`, currentData);
      }
    } else if (type === "schedule_duration") {
      if (scheduleObj?.startDate && scheduleObj?.endDate) {
        currentData = [
          moment(scheduleObj.startDate).format("YYYY-MM-DD"),
          moment(scheduleObj.endDate).format("YYYY-MM-DD"),
        ];

        currentTimeData = {
          startTime: moment(scheduleObj.startDate).format("HH:mm"),
          endTime: moment(scheduleObj.endDate).format("HH:mm"),
        };
        // console.log(`[${type}] Loading dates from scheduleObj:`, currentData);
      } else if (dateValue[type]?.data) {
        currentData = dateValue[type].data;
        currentTimeData = timeValue[type]?.data || defaultDates.time;
        // console.log(`[${type}] Loading dates from Redux:`, currentData);
      } else {
        currentData = defaultDates.date;
        currentTimeData = defaultDates.time;
        // console.log(`[${type}] Using default dates:`, currentData);
      }
    } else if (type === "schedule_date_time") {
      if (scheduleObj?.startDate && !scheduleObj?.IsScheduled) {
        currentData = [
          moment(scheduleObj.startDate).format("YYYY-MM-DD"),
          moment(scheduleObj.endDate).format("YYYY-MM-DD"),
        ];

        currentTimeData = {
          startTime: moment(scheduleObj.startDate).format("HH:mm"),
          endTime: moment(scheduleObj.endDate).format("HH:mm"),
        };
        // console.log(`[${type}] Loading dates from scheduleObj:`, currentData);
      } else if (dateValue[type]?.data) {
        currentData = dateValue[type].data;
        currentTimeData = timeValue[type]?.data || defaultDates.time;
        // console.log(`[${type}] Loading dates from Redux:`, currentData);
      } else {
        currentData = defaultDates.date;
        currentTimeData = defaultDates.time;
        // console.log(`[${type}] Using default dates:`, currentData);
      }
    }
    // Set local state without triggering Redux dispatch
    setLocalDate(currentData);
    setLocalTime(currentTimeData);
    // Initialize date picker controls from localDate
    if (Array.isArray(currentData) && currentData.length === 2) {
      try {
        let startDate = moment(currentData[0]);
        let endDate = moment(currentData[1]);
        const diffDays = endDate.diff(startDate, "days");

        // console.log(
        //   `Initializing from date range: ${startDate.format(
        //     "YYYY-MM-DD"
        //   )} to ${endDate.format("YYYY-MM-DD")}, diff: ${diffDays} days`
        // );

        // Default assignments from start date
        let selectedYearValue = startDate.year();
        let selectedMonthValue = startDate.month();
        let selectedDateValue = startDate.date();

        // Get today's moment
        const todayMoment = moment();

        // Determine the type based on the date range
        // Determine the duration type and adjust defaults if needed
        if (diffDays === 0) {
          // Single day
          // Daily: do not allow today. If startDate is today, use previous day.
          if (startDate.isSame(todayMoment, "day")) {
            startDate = moment().subtract(1, "day");
            // console.log(
            //   `Daily: Default date was today; adjusting to previous day: ${startDate.format(
            //     "YYYY-MM-DD"
            //   )}`
            // );
          }
          setDurationType("daily");
        } else if (diffDays <= 7) {
          // Weekly: do not allow the current or future week.
          setDurationType("weekly");
          const weeks = calculateWeeks(startDate.month(), startDate.year());
          let weekObj = weeks.find(
            (w) =>
              (startDate.isSameOrAfter(w.startDate, "day") &&
                startDate.isSameOrBefore(w.endDate, "day")) ||
              (endDate.isSameOrAfter(w.startDate, "day") &&
                endDate.isSameOrBefore(w.endDate, "day"))
          );
          // If the found week is current or future, try to pick the previous week.
          if (weekObj) {
            const now = moment();
            if (
              now.isBetween(weekObj.startDate, weekObj.endDate, "day", "[]") ||
              weekObj.startDate.isAfter(now, "day")
            ) {
              // Get all weeks for the month and pick the previous week (if exists)
              const currentWeekIndex = weeks.findIndex(
                (w) => w.weekNumber === weekObj.weekNumber
              );
              if (currentWeekIndex > 0) {
                weekObj = weeks[currentWeekIndex - 1];
                // console.log(
                //   `Weekly: Default week was current/future; adjusting to previous week: Week ${weekObj.weekNumber}`
                // );
              }
            }
            setSelectedWeek(weekObj.weekNumber);
            // console.log(`Weekly: No matching week found; defaulting to week 1`);
          } else {
            setSelectedWeek(1);
            // console.log(`Setting durationType to weekly, default week 1`);
          }
        } else if (startDate.month() === endDate.month()) {
          // Same month
          // Monthly: do not allow the current month.
          setDurationType("monthly");
          const currentMonth = todayMoment.month();
          const currentYear = todayMoment.year();
          if (
            selectedYearValue === currentYear &&
            selectedMonthValue === currentMonth
          ) {
            // If the selected month is the current month, adjust to the previous month
            const previousMonthMoment = moment(startDate).subtract(1, "month");
            selectedYearValue = previousMonthMoment.year();
            selectedMonthValue = previousMonthMoment.month();
            // Clamp day if necessary
            const newMonthDays = previousMonthMoment.daysInMonth();
            if (selectedDateValue > newMonthDays) {
              selectedDateValue = newMonthDays;
            }
            // console.log(
            //   `Monthly: Default month was current; adjusting to previous month: ${previousMonthMoment.format(
            //     "MMMM YYYY"
            //   )}`
            // );
          }

          // console.log(
          //   `Setting durationType to monthly for ${startDate.format(
          //     "MMMM YYYY"
          //   )}`
          // );
        } else {
          // Different months, default to showing the start month
          setDurationType("monthly");
          // console.log(
          //   `Dates span multiple months, defaulting to monthly view for ${startDate.format(
          //     "MMMM YYYY"
          //   )}`
          // );
        }
        // Finally set the selected values from the (possibly adjusted) startDate.
        setSelectedYear(selectedYearValue);
        setSelectedMonth(selectedMonthValue);
        setSelectedDate(selectedDateValue);
        // Also, update the display text based on the adjusted values
        if (Array.isArray(currentData) && currentData.length === 2) {
          try {
            // Use the actual date range to determine what to display
            if (diffDays === 0) {
              // Single day
              // Daily
              // const text = `${startDate.date()} ${startDate.format(
              //   "MMMM"
              // )}, ${startDate.year()}`;

              const text = `${selectedDateValue} ${moment()
                .month(selectedMonthValue)
                .format("MMMM")}, ${selectedYearValue}`;
              // console.log(`Setting initial display text (daily): ${text}`);
              setDisplayText(text);
            } else if (diffDays <= 7) {
              // Weekly
              const weeks = calculateWeeks(
                selectedMonthValue,
                selectedYearValue
              );
              const weekObj = weeks.find(
                (w) =>
                  (startDate.isSameOrAfter(w.startDate, "day") &&
                    startDate.isSameOrBefore(w.endDate, "day")) ||
                  (endDate.isSameOrAfter(w.startDate, "day") &&
                    endDate.isSameOrBefore(w.endDate, "day"))
              );

              if (weekObj) {
                // const text = `Week ${weekObj.weekNumber} of ${startDate.format(
                //   "MMMM"
                // )}, ${startDate.year()}`;

                const text = `Week ${weekObj.weekNumber} of ${moment()
                  .month(selectedMonthValue)
                  .format("MMMM")}, ${selectedYearValue}`;

                // console.log(`Setting initial display text (weekly): ${text}`);
                setDisplayText(text);
              } else {
                // const text = `Week 1 of ${startDate.format(
                //   "MMMM"
                // )}, ${startDate.year()}`;

                const text = `Week 1 of ${moment()
                  .month(selectedMonthValue)
                  .format("MMMM")}, ${selectedYearValue}`;

                // console.log(
                //   `Setting initial display text (weekly fallback): ${text}`
                // );
                setDisplayText(text);
              }
            } else if (startDate.month() === endDate.month()) {
              // Monthly
              // const text = `${startDate.format("MMMM")}, ${startDate.year()}`;

              const text = `${moment()
                .month(selectedMonthValue)
                .format("MMMM")}, ${selectedYearValue}`;

              // console.log(`Setting initial display text (monthly): ${text}`);
              setDisplayText(text);
            } else {
              // Default to a custom range display
              const text = `${startDate.format(
                "DD MMM YYYY"
              )} - ${endDate.format("DD MMM YYYY")}`;
              // console.log(
              //   `Setting initial display text (custom range): ${text}`
              // );
              setDisplayText(text);
            }
          } catch (error) {
            // console.error("Error generating initial display text:", error);
            setDisplayText("Select duration");
          }
        } else {
          setDisplayText("Select duration");
        }
      } catch (error) {
        // console.error("Error parsing dates:", error);
        // Set fallback values if error occurs
        setDurationType("daily");
        setSelectedDate(moment().subtract(1, "day").date());
        setSelectedMonth(moment().month());
        setSelectedYear(moment().year());
      }
    } else {
      // console.log("No valid date array found, using default values");
      // No valid data, use defaults
      setDurationType("daily");
      setSelectedDate(moment().subtract(1, "day").date());
      setSelectedMonth(moment().month());
      setSelectedYear(moment().year());
    }
  };

  // Update display text when selection changes
  useEffect(() => {
    if (isCalendarVisible) {
      updateSelectionDisplayText();
    }
  }, [
    durationType,
    selectedMonth,
    selectedDate,
    selectedWeek,
    selectedYear,
    isCalendarVisible,
  ]);

  // Function to update the display text based on selected date parameter
  const updateSelectionDisplayText = () => {
    const monthName = moment().month(selectedMonth).format("MMMM");
    const year = selectedYear;
    let text = "Select duration";

    try {
      if (durationType === "daily") {
        // Daily format: "15 January, 2023"
        text = `${selectedDate} ${monthName}, ${year}`;
        // console.log(`Setting display text for user selection (daily): ${text}`);
      } else if (durationType === "weekly") {
        // Weekly format: "Week 2 of January, 2023"
        text = `Week ${selectedWeek} of ${monthName}, ${year}`;
        // console.log(
        //   `Setting display text for user selection (weekly): ${text}`
        // );
      } else if (durationType === "monthly") {
        // Monthly format: "January, 2023"
        text = `${monthName}, ${year}`;
        // console.log(
        //   `Setting display text for user selection (monthly): ${text}`
        // );
      }
    } catch (error) {
      // console.error("Error updating selection display text:", error);
      text = "Select duration";
    }

    setDisplayText(text);
  };

  // Calculate position for popup
  useEffect(() => {
    // Only run this when calendar is opened
    if (!isCalendarVisible) return;

    // Use timeout to ensure the popup is rendered before measuring
    const timer = setTimeout(() => {
      if (containerRef.current && popupRef.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const popupRect = popupRef.current.getBoundingClientRect();
        const windowWidth = window.innerWidth;

        if (containerRect.left + popupRect.width > windowWidth) {
          setPopupPosition({
            right: 0,
            left: "auto",
          });
        } else {
          setPopupPosition({
            left: 0,
            right: "auto",
          });
        }
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [isCalendarVisible]);

  // Calculate 4 equal weeks for a given month and year
  // const calculateWeeks = (month, year) => {
  //   const weeks = [];
  //   const firstDayOfMonth = moment(`${year}-${month + 1}-01`);
  //   const lastDayOfMonth = moment(firstDayOfMonth).endOf("month");
  //   const daysInMonth = lastDayOfMonth.date();
  //   const daysPerWeek = Math.ceil(daysInMonth / 4);

  //   for (let weekNum = 1; weekNum <= 4; weekNum++) {
  //     const startDate = moment(
  //       `${year}-${month + 1}-${(weekNum - 1) * daysPerWeek + 1}`
  //     );

  //     let endDay = weekNum * daysPerWeek;
  //     if (endDay > daysInMonth) {
  //       endDay = daysInMonth;
  //     }

  //     const endDate = moment(`${year}-${month + 1}-${endDay}`);

  //     weeks.push({
  //       weekNumber: weekNum,
  //       startDate: startDate,
  //       endDate: endDate,
  //       displayText: `${startDate.format("DD MMM")} - ${endDate.format(
  //         "DD MMM"
  //       )}`,
  //     });
  //   }

  //   return weeks;
  // };

  // Calculate weeks for a given month and year , every week have 7 days
  const calculateWeeks = (month, year) => {
    const weeks = [];
    // Create a moment for the first day of the month.
    const firstDayOfMonth = moment({ year, month, day: 1 });
    const daysInMonth = firstDayOfMonth.daysInMonth();

    let weekNumber = 1;
    // Loop through the days of the month in steps of 7.
    for (let day = 1; day <= daysInMonth; day += 7) {
      const startDate = moment({ year, month, day });
      // Add 6 days to get a 7-day week.
      let endDate = moment(startDate).add(6, "days");
      // If the calculated endDate goes past the month, clamp it to the month's last day.
      if (endDate.month() !== month) {
        endDate = moment({ year, month, day: daysInMonth });
      }

      weeks.push({
        weekNumber,
        startDate,
        endDate,
        displayText: `${startDate.format("DD MMM")} - ${endDate.format(
          "DD MMM"
        )}`,
      });
      if (weekNumber >= 4) break; // only allow 4 weeks currently, if in future want to show 5 week then remove this condition
      weekNumber++;
    }

    return weeks;
  };

  // Toggle calendar visibility
  const toggleCalendar = () => {
    setIsCalendarVisible(!isCalendarVisible);
  };

  // Close calendar
  const closeCalendar = () => {
    setIsCalendarVisible(false);
  };
  const checkIsFirstWeekOngoing = () => {
    const today = moment();
    const currentMonth = today.month();
    const currentYear = today.year();
    const weeks = calculateWeeks(currentMonth, currentYear);
    if (weeks.length > 0) {
      const firstWeek = weeks[0];
      return today.isBetween(
        firstWeek.startDate,
        firstWeek.endDate,
        "day",
        "[]"
      );
    }
    return false;
  };
  // Helper to get previous month and year
  const getPreviousMonthYear = (month, year) => {
    if (month > 0) {
      return { month: month - 1, year };
    } else {
      return { month: 11, year: year - 1 };
    }
  };
  // Handle duration type change
  const handleDurationTypeChange = (e) => {
    const newDurationType = e.target.value;

    const currentYear = moment().year();
    const currentMonth = moment().month(); // 0-indexed: January is 0
    if (newDurationType === "monthly") {
      // If the new year is the current year and the previously selected month is in the future, reset it.
      if (selectedYear === currentYear && selectedMonth >= currentMonth) {
        const { month: newMonth, year: newYear } = getPreviousMonthYear(
          currentMonth,
          currentYear
        );
        setSelectedMonth(newMonth);
        setSelectedYear(newYear);
        setSelectedDate(adjustDateForYearMonth(newYear, newMonth));
      } else {
        // Otherwise, simply adjust the selected date if needed.
        setSelectedDate(adjustDateForYearMonth(selectedYear, selectedMonth));
      }
    } else if (newDurationType === "weekly") {
      // For weekly, check if we're in the first week of the current month.
      const isFirstWeekOngoing = checkIsFirstWeekOngoing();
      if (
        selectedYear === currentYear &&
        selectedMonth === currentMonth &&
        isFirstWeekOngoing
      ) {
        // If we are in the first week of the current month, force back to previous month.
        const { month: newMonth, year: newYear } = getPreviousMonthYear(
          currentMonth,
          currentYear
        );
        setSelectedMonth(newMonth);
        setSelectedYear(newYear);
        setSelectedWeek(4); // Reset to the last week of the previous month
        setSelectedDate(adjustDateForYearMonth(newYear, newMonth));
      } else if (
        selectedYear === currentYear &&
        selectedMonth >= currentMonth
      ) {
        // If the selected month is in the future, force it back to the current month.
        setSelectedMonth(currentMonth);
        setSelectedWeek(1);
        setSelectedDate(adjustDateForYearMonth(selectedYear, currentMonth));
      } else {
        // Otherwise, simply clamp the date if necessary.
        setSelectedDate(adjustDateForYearMonth(selectedYear, selectedMonth));
      }
    } else if (newDurationType === "daily") {
      // For daily mode:
      // 1. If the new year is current and the selected month is in the future,
      //    force it back to the current month.
      // 2. If the new year is current, the selected month is the current month,
      //    and today is the first day of the month, then reset to the last day
      //    of the previous month.
      // 3. Otherwise, simply adjust the selected date as needed.
      const today = moment().date();
      if (selectedYear === currentYear && selectedMonth > currentMonth) {
        setSelectedMonth(currentMonth);
        setSelectedDate(adjustDateForYearMonth(selectedYear, currentMonth));
      } else if (
        selectedYear === currentYear &&
        selectedMonth === currentMonth &&
        today === 1
      ) {
        const { month: newMonth, year: newYear } = getPreviousMonthYear(
          currentMonth,
          currentYear
        );
        setSelectedMonth(newMonth);
        setSelectedYear(newYear);
        setSelectedDate(adjustDateForYearMonth(newYear, newMonth));
      } else {
        setSelectedDate(adjustDateForYearMonth(selectedYear, selectedMonth));
      }
    }
    setDurationType(newDurationType);
  };

  // Handle month selection
  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    setSelectedWeek(1);
    // Get the total number of days in the newly selected month
    const newMonthDays = moment({
      year: selectedYear,
      month: value,
    }).daysInMonth();
    const currentYear = moment().year();
    const currentMonth = moment().month(); // 0-indexed: January is 0
    const today = moment().date();

    // adjust the selected date.
    let newSelectedDate = selectedDate;

    // For current year & current or future month, if selectedDate is >= today, force to yesterday.
    if (selectedYear === currentYear && value >= currentMonth) {
      // If the previously selected date is greater than today,
      // reset it to the today of the this month.
      if (selectedDate >= today) {
        newSelectedDate = moment().subtract(1, "day").date();
      }
    }

    // Ensure the adjusted date doesn't exceed the number of days in the new month.
    if (newSelectedDate > newMonthDays) {
      newSelectedDate =
        newMonthDays > 1
          ? selectedYear <= currentYear && value < currentMonth
            ? newMonthDays
            : newMonthDays - 1
          : 1;
    }

    setSelectedDate(newSelectedDate);
  };

  // Handle date selection
  const handleDateChange = (value) => {
    setSelectedDate(value);
  };

  // Handle week selection
  const handleWeekChange = (value) => {
    setSelectedWeek(value);
  };

  // Helper: Adjust the selected date based on the given year and month.
  const adjustDateForYearMonth = (year, month) => {
    const monthDays = moment({ year, month }).daysInMonth();
    const today = moment().date();
    let newDate = selectedDate; // assume selectedDate is available in scope

    // Only assign the previous day if we're adjusting for the current year or the current month.
    // If the currently selected date is today or later, use yesterday
    if (
      year === moment().year() &&
      month === moment().month() &&
      selectedDate >= today
    ) {
      newDate = moment().subtract(1, "day").date();
    }
    // Clamp the date if it exceeds the days in the month.
    if (newDate > monthDays) {
      newDate =
        monthDays > 1
          ? year <= moment().year() && month < moment().month()
            ? monthDays
            : monthDays - 1
          : 1;
    }
    return newDate;
  };

  // Handle year selection
  const handleYearChange = (value) => {
    setSelectedYear(value);
    const currentYear = moment().year();
    const currentMonth = moment().month(); // 0-indexed: January is 0
    // If the new year is the current year and the previously selected month is in the future, reset it.
    if (durationType == "monthly") {
      // For monthly: if the new year is the current year and the selected month is the current month or later,
      // adjust to the previous month if available.
      if (value === currentYear && selectedMonth >= currentMonth) {
        // If not January, use the previous month; otherwise stay at January.
        const { month: newMonth, year: newYear } = getPreviousMonthYear(
          currentMonth,
          currentYear
        );
        setSelectedMonth(newMonth);
        setSelectedYear(newYear);
        setSelectedDate(adjustDateForYearMonth(newYear, newMonth));
      } else {
        // Otherwise, simply adjust the selected date if needed.
        setSelectedDate(adjustDateForYearMonth(value, selectedMonth));
      }
    } else if (durationType === "weekly") {
      // For weekly, determine if the current week is the first week of the month.
      // Get the first day of the current month and the start of the current week
      const isFirstWeekOngoing = checkIsFirstWeekOngoing();
      if (
        value === currentYear &&
        selectedMonth >= currentMonth &&
        isFirstWeekOngoing
      ) {
        // If the first week of the current month is ongoing, move to the previous month.
        // If not January, use the previous month; otherwise stay at January.
        const { month: newMonth, year: newYear } = getPreviousMonthYear(
          currentMonth,
          currentYear
        );
        setSelectedMonth(newMonth);
        setSelectedYear(newYear);
        setSelectedWeek(4); // Reset to the last week of the previous month
        setSelectedDate(adjustDateForYearMonth(newYear, newMonth));
      } else if (value === currentYear && selectedMonth >= currentMonth) {
        // If the selected month is in the future, force it back to the current month.
        setSelectedMonth(currentMonth);
        setSelectedWeek(1);
        setSelectedDate(adjustDateForYearMonth(value, currentMonth));
      } else {
        setSelectedDate(adjustDateForYearMonth(value, selectedMonth));
      }
    } else if (durationType === "daily") {
      // For daily mode:
      // 1. If the new year is current and the selected month is in the future,
      //    force it back to the current month.
      // 2. If the new year is current, the selected month is the current month,
      //    and today is the first day of the month, then reset to the last day
      //    of the previous month.
      // 3. Otherwise, simply adjust the selected date as needed.
      const today = moment().date();
      if (value === currentYear && selectedMonth > currentMonth) {
        // For daily, if the selected month is in the future, force it back to the current month.
        setSelectedMonth(currentMonth);
        setSelectedDate(adjustDateForYearMonth(value, currentMonth));
      } else if (
        value === currentYear &&
        selectedMonth === currentMonth &&
        today === 1
      ) {
        // If today is the first day, reset to previous month:
        const { month: newMonth, year: newYear } = getPreviousMonthYear(
          currentMonth,
          currentYear
        );
        setSelectedMonth(newMonth);
        setSelectedYear(newYear);
        // Set date to the last day of the new (previous) month.
        setSelectedDate(adjustDateForYearMonth(newYear, newMonth));
      } else {
        setSelectedDate(adjustDateForYearMonth(value, selectedMonth));
      }
    }
  };

  // Create date range object based on selection
  const createDateRangeObject = () => {
    let startDate, endDate;

    if (durationType === "daily") {
      startDate = moment(
        `${selectedYear}-${selectedMonth + 1}-${selectedDate}`
      );
      endDate = moment(startDate); // Same as start for daily
    } else if (durationType === "weekly") {
      const weeks = calculateWeeks(selectedMonth, selectedYear);
      const selectedWeekData =
        weeks.find((w) => w.weekNumber === selectedWeek) || weeks[0];
      startDate = selectedWeekData.startDate;
      endDate = selectedWeekData.endDate;
    } else if (durationType === "monthly") {
      startDate = moment(`${selectedYear}-${selectedMonth + 1}-01`);
      endDate = moment(startDate).endOf("month");
    }

    // Format dates with slashes instead of hyphens
    const from = startDate.format("YYYY/MM/DD");
    const to = endDate.format("YYYY/MM/DD");

    // Get current time values or use defaults
    let startTime = localTime?.startTime || "00:00";
    let endTime = localTime?.endTime || "23:59";

    // Return complete date range object
    return {
      from: `${from} ${startTime}`,
      to: `${to} ${endTime}`,
      days: endDate.diff(startDate, "days") + 1,
      relative: null,
    };
  };

  // updates redux state and sends proper selected duration
  const handleDone = () => {
    const dateObject = createDateRangeObject();

    if (type === "global_dashboard") {
      let index = getPaneIndex(panes, activeKey);
      let paneObject = {
        duration: dateObject,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        singleBrands: brands,
        index: index,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
        temporary_words: temporary_words,
        is_modified_date:
          index >= 0 &&
          (panes?.[index]?.template_id === "000-000-002" ||
            panes?.[index]?.template_id === "000-000-004")
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };

      dispatch(updateDashboardDuration(paneObject));

      // Only update global duration if not a campaign dashboard
      if (index >= 0 && panes?.[index]?.quick_filter !== "CampaignID") {
        dispatch(setGlobalDuration(dateObject));
      }

      // Update global widget selection
      dispatch(setGlobalSelectedWidgetId(visitedWidgetId));

      // Clear deep dive selection
      dispatch(setSelectedDeepdiveWidget(null, null, panes, index));

      let durationObject = {
        type: type,
        value: dateObject,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject));
    } else if (type === "template_global") {
      let templateObject = {
        duration: dateObject,
        selectBrands: templateDetails?.templateBrands?.columns
          ? templateDetails?.templateBrands?.columns?.length > 0
            ? templateDetails?.templateBrands?.columns
            : null
          : templateDetails?.templateBrands?.length
          ? templateDetails?.templateBrands
          : null,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        templateDetails: templateDetails,
        section: Section,
        filters: templateDetails?.templateFilters
          ? templateDetails?.templateFilters
          : [],
        type: type,
        change_type: "global_duration",
        graphConditionConfig: graphConditionConfig,
      };

      // Update template details with new duration
      dispatch(
        setTemplateDetails(templateDetails, {
          duration: dateObject,
          dashboard_called_api_list: [],
        })
      );

      // Carryforward create/edit template date to graph page date
      dispatch(setGraphDuration(dateObject, graphDetail));

      // Stop previous API calls because we're making global level changes
      // check check
      // if (window?.stop) {
      //   window.stop();
      // }

      dispatch(setTemplateFilter(templateObject));
      dispatch(setGlobalDuration(dateObject));

      let durationObject = {
        type: type,
        value: dateObject,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject));
    } else if (type === "share_modal") {
      dispatch(setSharedDuration(dateObject));

      let updatedShareTemplateData = { ...shareTemplateData };
      updatedShareTemplateData.duration = dateObject?.from
        ? {
            from: dateObject?.from,
            to: dateObject?.to,
          }
        : null;

      let shareObj = {
        shareBrands: shareBrands,
        duration: dateObject,
        shareData: updatedShareTemplateData,
        shareCategory: shareCategory,
        graphConditionConfig: graphConditionConfig,
        change_type: "global_duration",
      };

      dispatch(
        setClearGraphData(null, null, "share", shareObj, query?.get("share_id"))
      );

      // Set global selected widget id
      dispatch(setGlobalSelectedWidgetId(visitedWidgetId));

      // Clear selected widget deepdive for shared dashboard
      shareBrands && dispatch(setShareSelectedDeepdiveWidget(null));
    } else if (type === "schedule_duration") {
      const {
        selectedFrequency,
        selectedDataDuration,
        selectedLastXDays,
        scheduleDay,
        scheduleTime,
        scheduleMonth,
        TimeOffsetText,
      } = scheduleObj;

      const dates = handleScheduleDateChange(
        dateObject,
        selectedFrequency,
        selectedDataDuration,
        selectedLastXDays,
        scheduleDay,
        scheduleTime,
        scheduleMonth,
        TimeOffsetText
      );

      dispatch(
        setScheduleReport({
          ...scheduleObj,
          startDate: moment(dates?.startDate)
            .tz(TimeOffsetText?.split(" ")[1])
            .format("YYYY-MM-DD HH:mm:ss"),
          endDate: moment(dates?.endDate)
            .tz(TimeOffsetText?.split(" ")[1])
            .format("YYYY-MM-DD HH:mm:ss"),
        })
      );
    } else if (type === "schedule_date_time") {
      // Use handleGenerateDateChange for schedule_date_time
      const dates = handleGenerateDateChange(dateObject);

      dispatch(
        setScheduleReport({
          ...scheduleObj,
          startDate: dates?.startDate,
          endDate: dates?.endDate,
          relativeCount: dates?.relative,
        })
      );

      let durationObject = {
        type: type,
        value: dateObject,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGraphPageDateValue(durationObject));
    }

    // Call callback if provided
    if (onDoneCallback) {
      onDoneCallback(dateObject);
    }

    closeCalendar();
  };
  const currentYearForValidation = moment().year();
  // Generate year options (5 years in past and future)
  const yearOptions = Array.from({ length: 11 }, (_, i) => {
    const yearVal = currentYearForValidation - 10 + i;
    return {
      value: yearVal,
      label: yearVal,
      disabled: yearVal > currentYearForValidation, // Disable future years
    };
  });

  // Generate month options
  // const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  //   value: i,
  //   label: moment().month(i).format("MMMM"),
  // }));
  const getMonthOptions = (selectedYear = moment().year()) => {
    const currentYear = moment().year();
    const currentMonth = moment().month(); // 0-indexed: January is 0
    const today = moment().date(); // Get today's date

    // Check if the current week is the first week of the month
    // (i.e. the week in which the 1st day of the month falls)
    const isFirstWeekOngoing = checkIsFirstWeekOngoing();
    return Array.from({ length: 12 }, (_, i) => {
      // console.log(
      //   `getMonthOptions: i : ${i}, selectedYear : ${selectedYear}, currentYear : ${currentYear}, currentMonth : ${currentMonth}`
      // );
      return {
        value: i,
        label: moment().month(i).format("MMMM"),
        disabled:
          selectedYear === currentYear &&
          (durationType === "monthly"
            ? i >= currentMonth // Disable future months in the current year
            : durationType === "weekly"
            ? i > currentMonth || (i === currentMonth && isFirstWeekOngoing) // Disable current month if the current week is in the same month
            : durationType === "daily"
            ? i > currentMonth || (i === currentMonth && today === 1) // Disable current month if today is the 1st day
            : i > currentMonth), // Default: Disable future months
      };
    });
  };

  // Generate date options based on selected month
  const getDatesForMonth = (month, year) => {
    const daysInMonth = moment(`${year}-${month + 1}`, "YYYY-MM").daysInMonth();
    const now = moment();
    return Array.from({ length: daysInMonth }, (_, i) => {
      const day = i + 1;
      const currentDate = moment({ year, month, day });
      return {
        value: day,
        label: day,
        disabled: currentDate.isSameOrAfter(now, "day"),
      };
    });
  };

  // Generate week options based on selected month
  const getWeeksForMonth = (month, year) => {
    const weeks = calculateWeeks(month, year);
    const now = moment();
    return weeks.map((week) => {
      const weekStart = moment(week.startDate);
      const weekEnd = moment(week.endDate);

      // Disable the week if today is within the week (current week)
      // or if the week starts in the future.
      const disabled =
        now.isBetween(weekStart, weekEnd, "day", "[]") ||
        weekStart.isAfter(now, "day");

      return {
        value: week.weekNumber,
        label: `Week ${week.weekNumber}: ${week.displayText}`,
        disabled,
      };
    });
  };

  return (
    <div
      ref={containerRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      {/* Duration Display Box */}
      <div
        onClick={toggleCalendar}
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: "4px",
          padding: "8px 12px",
          cursor: "pointer",
          minWidth: "200px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>{displayText}</span>
        <DownOutlined />
      </div>

      {/* Calendar Popup */}
      {isCalendarVisible && (
        <div
          ref={popupRef}
          style={{
            position: "absolute",
            zIndex: 1000,
            top: "100%",
            ...popupPosition,
            width: "350px",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            backgroundColor: "white",
            boxShadow: "0 3px 6px rgba(0,0,0,0.16)",
            marginTop: "4px",
          }}
        >
          {/* Calendar Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <h3 style={{ margin: 0 }}>Select Duration</h3>
            <Button
              icon={<CloseOutlined />}
              type="text"
              onClick={closeCalendar}
              size="small"
            />
          </div>

          {/* Calendar Body */}
          <div style={{ padding: "16px" }}>
            {/* Duration Type Selection */}
            <div style={{ marginBottom: "16px" }}>
              <Radio.Group
                value={durationType}
                onChange={handleDurationTypeChange}
              >
                <Radio value="daily">Daily</Radio>
                <Radio value="weekly">Weekly</Radio>
                <Radio value="monthly">Monthly</Radio>
              </Radio.Group>
            </div>

            {/* Year Selector (common for all types) */}
            <div style={{ marginBottom: "16px" }}>
              <Select
                style={{ width: "100%" }}
                value={selectedYear}
                onChange={handleYearChange}
              >
                {yearOptions.map((option) => (
                  <Option
                    key={option.value}
                    value={option.value}
                    disabled={option?.disabled}
                  >
                    {option.label}
                  </Option>
                ))}
              </Select>
            </div>

            {/* Month Selector (common for all types) */}
            <div style={{ marginBottom: "16px" }}>
              <Select
                style={{ width: "100%" }}
                value={selectedMonth}
                onChange={handleMonthChange}
                placeholder="Select Month"
              >
                {getMonthOptions(selectedYear).map((option) => (
                  <Option
                    key={option.value}
                    value={option.value}
                    disabled={option?.disabled}
                  >
                    {option.label}
                  </Option>
                ))}
              </Select>
            </div>

            {/* Daily: Date Selector */}
            {durationType === "daily" && (
              <div style={{ marginBottom: "16px" }}>
                <Select
                  style={{ width: "100%" }}
                  value={selectedDate}
                  onChange={handleDateChange}
                  placeholder="Select Date"
                >
                  {getDatesForMonth(selectedMonth, selectedYear).map(
                    (option) => (
                      <Option
                        key={option.value}
                        value={option.value}
                        disabled={option?.disabled}
                      >
                        {option.label}
                      </Option>
                    )
                  )}
                </Select>
              </div>
            )}

            {/* Weekly: Week Selector */}
            {durationType === "weekly" && (
              <div style={{ marginBottom: "16px" }}>
                <Select
                  style={{ width: "100%" }}
                  value={selectedWeek}
                  onChange={handleWeekChange}
                  placeholder="Select Week"
                >
                  {getWeeksForMonth(selectedMonth, selectedYear).map(
                    (option) => (
                      <Option
                        key={option.value}
                        value={option.value}
                        disabled={option?.disabled}
                      >
                        {option.label}
                      </Option>
                    )
                  )}
                </Select>
              </div>
            )}

            {/* Weekly: Week Pills View */}
            {durationType === "weekly" && (
              <div
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {getWeeksForMonth(selectedMonth, selectedYear).map((week) => (
                  <div
                    key={week.value}
                    onClick={() => handleWeekChange(week.value)}
                    style={{
                      padding: "4px 12px",
                      borderRadius: "16px",
                      backgroundColor:
                        selectedWeek === week.value ? "#1890ff" : "#f0f0f0",
                      color:
                        selectedWeek === week.value
                          ? "white"
                          : "rgba(0, 0, 0, 0.85)",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    className={`${
                      week?.disabled ? "disable-with-no-drop" : ""
                    }`}
                  >
                    Week {week.value}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Calendar Footer */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "12px 16px",
              borderTop: "1px solid #f0f0f0",
              gap: "8px",
            }}
          >
            <Button onClick={closeCalendar}>Cancel</Button>
            <Button type="primary" onClick={handleDone}>
              Done
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDurationCalendar;
